export default class InitialProcessSetupService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('initialProcessSetup/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('initialProcessSetup', params)
	}

	getSettings(){
		return this.apiService.callGet('initialProcessSetup/settings');
	}

	updateEntity(id, params) {
		return this.apiService.callPut('initialProcessSetup/'+id, params)
	}

	createEntity(params){
		return this.apiService.callPost('initialProcessSetup/', params);
	}

	deleteEntity(id) {
		return this.apiService.callDelete('initialProcessSetup/'+id)
	}
}



// WEBPACK FOOTER //
// ./src/service/InitialProcessSetupService.js